module.exports = __webpack_public_path__ + "static/img/icon-3.63a83ee1.png";